import { render, staticRenderFns } from "./ChooseGoods.vue?vue&type=template&id=31102d34&scoped=true&"
import script from "./ChooseGoods.vue?vue&type=script&lang=js&"
export * from "./ChooseGoods.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoods.vue?vue&type=style&index=0&id=31102d34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31102d34",
  null
  
)

export default component.exports